import type { ProgressData } from "@shared/types.ts"

const STORAGE_PREFIX = "cword:progress:"

type SavedState = Omit<ProgressData, "updatedAt"> & { updatedAt: string }

export function saveLocal(slug: string, state: SavedState): void {
  try {
    localStorage.setItem(STORAGE_PREFIX + slug, JSON.stringify(state))
  } catch {
    // localStorage full or unavailable — silently ignore
  }
}

export function loadLocal(slug: string): SavedState | null {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + slug)
    if (!raw) return null
    return JSON.parse(raw) as SavedState
  } catch {
    return null
  }
}

export function clearLocal(slug: string): void {
  try {
    localStorage.removeItem(STORAGE_PREFIX + slug)
  } catch {
    // ignore
  }
}
